import { SVGProps } from 'react';
import { BaseContainerComponentPropsType } from '../../util/types';
import AvatarArtwork, { type RenderShadowFn } from '../AvatarArtwork';
import { avatarDefaultBackgroundColors } from '../../config/avatarColors';

const renderShadow: RenderShadowFn = (props) => (
  <polygon
    points="48.3 32.48 47.91 47.82 25.68 47.91 9.91 25.95 12.39 25.3 19.27 26.97 13.95 17 20.17 22.57 22.76 26.76 18.41 11.73 24 16.6 25.67 29.58 25.43 8.75 48.3 32.48"
    {...props}
  />
);

const AvatarArtworkPaleMan = (
  props: {
    backgroundColor?: string;
  } & BaseContainerComponentPropsType &
    SVGProps<SVGSVGElement>,
) => (
  <AvatarArtwork
    {...props}
    defaultBackgroundColor={avatarDefaultBackgroundColors.paleMan}
    renderShadow={renderShadow}
  >
    <>
      <path
        d="M36.29,20a29.14,29.14,0,0,0-1,3.16,11.84,11.84,0,0,1-1.17,4.43c-.37.66-.87,1.75-1.33,2.81s.58,3.63-.52,5.66c-.91,1.68-5,4.08-9.16,2.38-1.68-.67-2.84-3.41-3.58-4.67-1-1.74-1-2.36-5.49-4.7A12.14,12.14,0,0,1,10,25.67s1.21-.76,3.36.38c1.05.56,5.61,2.42,5.61,2.42a30.94,30.94,0,0,0-2.67-4.23c-1.56-2.1-5.58-8-5.58-8a3.89,3.89,0,0,1,3.92,1.87c1.08,1.55,6.45,7.65,6.63,7.5-4.63-9.1-4.78-15.76-4.78-15.76a7.53,7.53,0,0,1,3,3.57c.64,1.82,1.64,5.2,2.43,7.05C23,23,24,23.65,23.94,23.59A41.87,41.87,0,0,1,25.59,9.18a7,7,0,0,1,1,3.79c-.08,2-.19,8.07.5,9.6.15.33,1.46,2.36,1.71,2.69a7.63,7.63,0,0,0,1.69,1.84,4.69,4.69,0,0,0,2.19-3.44C33,21.32,36.29,20,36.29,20Z"
        style={{ fill: '#ede3d9' }}
      />
      <path
        d="M26.1,39.31a8.11,8.11,0,0,1-3.05-.6c-1.44-.58-2.47-2.51-3.23-3.93-.17-.32-.33-.61-.47-.84s-.2-.36-.3-.52c-.76-1.35-1.15-2-5.09-4.09a12.38,12.38,0,0,1-4.17-3.52.25.25,0,0,1,0-.19.31.31,0,0,1,.12-.16c.05,0,1.36-.83,3.61.37.79.42,3.65,1.61,4.94,2.14a33.17,33.17,0,0,0-2.32-3.58c-1.54-2.08-5.55-8-5.59-8a.29.29,0,0,1,0-.24.26.26,0,0,1,.17-.15,4.15,4.15,0,0,1,4.19,2c.84,1.22,4,4.85,5.6,6.54-4-8.43-4.21-14.58-4.21-14.65a.26.26,0,0,1,.13-.22.28.28,0,0,1,.25,0,7.73,7.73,0,0,1,3.07,3.71c.22.61.47,1.39.75,2.24.54,1.67,1.16,3.57,1.68,4.79A10.36,10.36,0,0,0,23.64,23,43.27,43.27,0,0,1,25.35,9.1a.25.25,0,0,1,.2-.17A.27.27,0,0,1,25.8,9,7.21,7.21,0,0,1,26.88,13c-.1,2.69-.13,8.13.48,9.49.14.3,1.44,2.32,1.68,2.64a8.75,8.75,0,0,0,1.49,1.67,4.29,4.29,0,0,0,1.94-3.15c.29-2.46,3.59-3.77,3.73-3.82a.25.25,0,0,1,.27.05.25.25,0,0,1,.06.26,29.88,29.88,0,0,0-1,3.12c0,.19,0,.39-.08.59a10.37,10.37,0,0,1-1.11,3.92c-.4.71-.94,1.91-1.32,2.79a4.23,4.23,0,0,0,0,1.61,7.19,7.19,0,0,1-.49,4.07C31.8,37.56,29.2,39.31,26.1,39.31ZM10.39,25.77a12.42,12.42,0,0,0,3.81,3.12c4.06,2.13,4.5,2.89,5.29,4.28l.29.51c.15.24.3.54.48.86.72,1.35,1.71,3.2,3,3.71,4,1.63,8-.64,8.85-2.27a6.85,6.85,0,0,0,.44-3.79,4.13,4.13,0,0,1,.07-1.85c.39-.89.93-2.1,1.34-2.83A9.9,9.9,0,0,0,35,23.76c0-.2,0-.4.08-.59a22.16,22.16,0,0,1,.78-2.66C35,21,33.16,22.08,33,23.69a5,5,0,0,1-2.28,3.61.26.26,0,0,1-.28,0,7.71,7.71,0,0,1-1.77-1.91c-.24-.32-1.57-2.38-1.73-2.73-.82-1.81-.54-9.4-.53-9.72a6.75,6.75,0,0,0-.72-3.14,41.66,41.66,0,0,0-1.47,13.75.25.25,0,0,1-.19.26c-.32.1-1.41-1.1-2.34-3.29-.53-1.25-1.15-3.15-1.7-4.84-.27-.84-.53-1.62-.74-2.22a7.1,7.1,0,0,0-2.45-3.17A42.73,42.73,0,0,0,21.5,25.46a.27.27,0,0,1-.06.31.39.39,0,0,1-.21.06c-.57-.08-6.13-6.65-6.79-7.61a3.73,3.73,0,0,0-3.28-1.81c.88,1.29,4,5.9,5.34,7.68a31.56,31.56,0,0,1,2.69,4.27.25.25,0,0,1-.32.34c-.18-.08-4.58-1.87-5.62-2.43A3.75,3.75,0,0,0,10.39,25.77Z"
        style={{ fill: '#d3cac2' }}
      />
      <path
        d="M30.61,32.77a7,7,0,0,1-4.28,1.87,7,7,0,0,1-4.28-1.87A13.9,13.9,0,0,0,24.2,32a7.87,7.87,0,0,1,2.52-.28A7.44,7.44,0,0,1,30.61,32.77Z"
        style={{ fill: '#fff' }}
      />
      <circle cx="27.05" cy="32.69" r="1.04" style={{ fill: '#3e1a3b' }} />
      <path d="M30.53,27.1S29,28.55,28.84,29.56" style={{ fill: '#f9d6bb' }} />
      <path
        d="M28.84,29.81h0a.25.25,0,0,1-.21-.28,6.5,6.5,0,0,1,1.77-2.6.26.26,0,0,1,.36,0,.25.25,0,0,1,0,.35,5.82,5.82,0,0,0-1.61,2.31A.26.26,0,0,1,28.84,29.81Z"
        style={{ fill: '#d3cac2' }}
      />
      <path
        d="M19.36,30.78l.38-.59a13.76,13.76,0,0,1,6.59-5.31h0"
        style={{ fill: '#ede3d9' }}
      />
      <path
        d="M19.36,31a.23.23,0,0,1-.14,0,.26.26,0,0,1-.07-.35l.38-.58a14.06,14.06,0,0,1,6.71-5.42.25.25,0,0,1,.18.47A13.44,13.44,0,0,0,20,30.33l-.38.59A.26.26,0,0,1,19.36,31Z"
        style={{ fill: '#d3cac2' }}
      />
      <path
        d="M26.33,34.89A7.13,7.13,0,0,1,21.88,33a.26.26,0,0,1-.08-.23.26.26,0,0,1,.16-.18,16.73,16.73,0,0,1,4.76-1.05,13.79,13.79,0,0,1,4,1.05.26.26,0,0,1,.15.19.26.26,0,0,1-.07.22A7.17,7.17,0,0,1,26.33,34.89Zm-3.79-2a6.47,6.47,0,0,0,3.79,1.52,6.45,6.45,0,0,0,3.81-1.54A11.89,11.89,0,0,0,26.72,32,15,15,0,0,0,22.54,32.87Z"
        style={{ fill: '#d3cac2' }}
      />
      <path
        d="M22.84,31.37a7.2,7.2,0,0,1,2.72-1.13,6.22,6.22,0,0,1,2.72.29"
        style={{ fill: '#ede3d9' }}
      />
      <path
        d="M22.84,31.62a.26.26,0,0,1-.2-.11.25.25,0,0,1,.06-.35A7.53,7.53,0,0,1,25.53,30a6.42,6.42,0,0,1,2.84.3.25.25,0,0,1-.18.47,6.09,6.09,0,0,0-2.59-.27A7,7,0,0,0,23,31.57.27.27,0,0,1,22.84,31.62Z"
        style={{ fill: '#d3cac2' }}
      />
      <path
        d="M29.31,35a7.09,7.09,0,0,1-2.83.8,6.13,6.13,0,0,1-2.66-.6"
        style={{ fill: '#ede3d9' }}
      />
      <path
        d="M26.37,36.06a6.35,6.35,0,0,1-2.66-.63.23.23,0,0,1-.11-.33.25.25,0,0,1,.33-.11,6,6,0,0,0,2.55.57,7.06,7.06,0,0,0,2.71-.77.25.25,0,1,1,.24.44,7.49,7.49,0,0,1-2.94.83Z"
        style={{ fill: '#d3cac2' }}
      />
    </>
  </AvatarArtwork>
);
export default AvatarArtworkPaleMan;
